<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <ListarArchivos :show-delete="showDelete" :archivos="archivos"></ListarArchivos>
    <hr>
    <div class="mt-5">
      <SubirArchivo  v-on:archivo="appendArchivo" :padre="padre" :paciente="paciente"></SubirArchivo>
    </div>
    <div style="text-align: right">
      <b-button variant="outline-primary"
      @click="guardarArchivos">
        <b-icon icon="upload"></b-icon>
        Guardar Archivos
      </b-button>
    </div>
  </div>
</template>

<script>
import ListarArchivos from "@/components/archivos/ListarArchivos";
import SubirArchivo from "@/components/archivos/SubirArchivo";
import {MovimientoService} from "@/apiServices/movimiento/MovimientoService";
export default {
  name: "ListarYSubirArchivos",
  components: {SubirArchivo, ListarArchivos},
  props: {
    showDelete:{
      type:  Boolean,
      required: true,
    },
    archivos: {
      type: Array
    },
    padre: {
      type: String
    },
    paciente: {
      type: Number
    },
    idMovimiento:{
      type: Number
    },
    estatus: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    archivosNuevos: [],
    movimientoService: new MovimientoService()
  }),
  methods: {
    appendArchivo(archivo) {
      this.archivosNuevos.push(archivo);
    },
    guardarArchivos(){
      if (this.archivosNuevos.length === 0){
        this.$swal({
          icon: "error",
          text: "No has cargado ningún archivo.",
        });
        return false;
      }else{
        this.movimientoService.guardarArchivos(this.idMovimiento, this.archivosNuevos.map(a => a.idArchivo)).then(() =>{
          this.$root.$emit('reload-reembolsos','force')
          this.$root.$emit('bv::hide::modal','archivos-'+this.idMovimiento)
        });
      }
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
